// Delegated swatch interaction (supports original + Swiper cloned slides)
function handleSwatchActivation(swatch) {
  const card = swatch.closest(".display-product-card");
  if (!card) return;

  const image = card.querySelector(".display-product-image");
  const price = card.querySelector(".display-product-price");
  const oldPrice = card.querySelector(".display-product-old-price");
  const button = card.querySelector(".display-product-button");

  card.querySelectorAll(".display-product-swatch").forEach(el => {
    el.classList.remove("active");
  });
  swatch.classList.add("active");

  const newImage = swatch.dataset.image;
  const newPrice = swatch.dataset.price;
  const newCompare = swatch.dataset.compare;
  const newDiscount = swatch.dataset.discount;
  const available = swatch.dataset.available === "true";
  const variantId = swatch.dataset.variantId;
  if (button && variantId) {
    button.dataset.variantId = variantId;
  }

  if (image && newImage) image.src = newImage;
  if (price && newPrice) price.innerHTML = newPrice;

  if (oldPrice && newCompare !== '') {
    oldPrice.innerHTML = newCompare;
  }

  const discountBadge = card.querySelector(".discount-percent");
  if (discountBadge && newDiscount) {
    discountBadge.innerHTML = newDiscount;
  }

  if (button) {
    if (available) {
      button.innerHTML = "Buy Now";
      button.classList.remove("sold-out");
      button.disabled = false;
    } else {
      button.innerHTML = "Sold Out";
      button.classList.add("sold-out");
      button.disabled = true;
    }
  }
}

// Swatch event listeners using event delegation
document.addEventListener("mouseenter", function (e) {
  const swatch = e.target.closest && e.target.closest(".display-product-swatch");
  if (swatch) handleSwatchActivation(swatch);
}, true);

document.addEventListener("click", function (e) {
  const swatch = e.target.closest && e.target.closest(".display-product-swatch");
  if (swatch) {
    e.preventDefault();
    handleSwatchActivation(swatch);
  }
});

// Delegated click handler for Buy Now buttons (works 100% on original & Swiper cloned slides!)
document.addEventListener("click", async function (e) {
  const button = e.target.closest && e.target.closest(".display-product-button");
  if (!button) return;

  if (button.disabled) return;
  e.preventDefault();

  let variantId = button.dataset.variantId;
  if (!variantId) {
    const form = button.closest("form");
    const idInput = form ? form.querySelector('input[name="id"]') : null;
    if (idInput) variantId = idInput.value;
  }
  if (!variantId) {
    const card = button.closest(".display-product-card");
    const idInput = card ? card.querySelector('.product-variant-id') : null;
    if (idInput) variantId = idInput.value;
  }

  if (!variantId) {
    alert("Please select a variant.");
    return;
  }

  // Prevent double click trigger
  if (button.dataset.loading === "true") return;
  button.dataset.loading = "true";
  const originalText = button.innerHTML;
  button.innerHTML = "Loading...";

  try {
    const card = button.closest(".display-product-card");
    const isBogo = card ? card.dataset.isBogo === "true" : false;
    const isGiftEligible = card ? card.dataset.isGiftEligible === "true" : false;
    const buyQty = isBogo ? 2 : 1;

    const payload = {
      id: variantId,
      quantity: buyQty
    };

    if (isGiftEligible) {
      payload.properties = {
        'Free Gift': '🎁 1 Free Gift included with this product'
      };
    }

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error("Failed to add to cart");
    }

    // Redirect to checkout (true Buy Now behavior)
    window.location.href = "/checkout";

  } catch (error) {
    console.error(error);
    button.dataset.loading = "false";
    button.innerHTML = originalText;
    alert("Unable to add the product to cart.");
  }
});